export const CONSTANTS = {
  LIMIT_TITLE_CHARACTER: 250,
  INCIDENT_TYPE: 1,
  REQUEST_TYPE: 10,
  INCIDENT_TYPE_IN_TEXT: 'incident',
  REQUEST_TYPE_IN_TEXT: 'request',
};
